import { render, staticRenderFns } from "./ApprovalProcess.vue?vue&type=template&id=713cfdcb&scoped=true"
import script from "./ApprovalProcess.vue?vue&type=script&lang=js"
export * from "./ApprovalProcess.vue?vue&type=script&lang=js"
import style0 from "./ApprovalProcess.vue?vue&type=style&index=0&id=713cfdcb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713cfdcb",
  null
  
)

export default component.exports